import { Fragment } from 'react'

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'
import { Box, Link, Typography } from '@mui/material'

export interface ShowcaseCrumb {
  label: string
  /** When provided the crumb is a link; the final (current) crumb omits it. */
  onClick?: () => void
}

interface ShowcaseBreadcrumbProps {
  crumbs: ShowcaseCrumb[]
}

/** Compact breadcrumb trail for the detail views (‹ Market / … / current). */
export const ShowcaseBreadcrumb = ({ crumbs }: ShowcaseBreadcrumbProps) => (
  <Box sx={{ fontSize: '0.75rem', color: 'text.secondary', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
    {crumbs.map((crumb, index) => (
      <Fragment key={`${crumb.label}-${index}`}>
        {index > 0 && <Box component="span">{'/'}</Box>}
        {crumb.onClick ? (
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={crumb.onClick}
            sx={{ fontSize: '0.75rem', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: 0.25 }}
          >
            {/* The first crumb ("Market") acts as the back-to-overview link, so the
                leading chevron is part of that link rather than a separate control. */}
            {index === 0 && <ChevronLeftRoundedIcon sx={{ fontSize: '1.1rem', ml: -0.25 }} />}
            {crumb.label}
          </Link>
        ) : (
          <Typography component="span" sx={{ fontSize: '0.75rem' }}>
            {crumb.label}
          </Typography>
        )}
      </Fragment>
    ))}
  </Box>
)
